import React from "react";
import { Radar } from "lucide-react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import CoverageSearchEmbed from "../components/coverage/CoverageSearchEmbed";

// Standalone free-search module. Never persists the result.
const CoverageSearchPage = () => {
  const { canView } = useAuth();
  if (!canView("coverage_search")) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl md:text-3xl font-heading font-semibold text-white flex items-center gap-3">
            <Radar className="h-8 w-8 text-[#03BEE4]" />
            Buscador de Cobertura
          </h1>
        </div>
      </div>
      <CoverageSearchEmbed />
      <p className="text-xs text-slate-500">
        El resultado queda en esta pantalla — no se guarda todavía en la base de datos.
      </p>
    </div>
  );
};

export default CoverageSearchPage;
